import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { IInvoice } from "../../interfaces/invoice.interface";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { FormArray, FormGroup, Validators } from "@angular/forms";
import { InvoiceService } from "../../invoice.service";
import { UtilsService } from "../../../../auth/service/utils.service";
import moment from "moment";
import { Router } from "@angular/router";
import { utc } from "moment/moment";

@Component({
  selector: "app-credit-note-create",
  templateUrl: "./credit-note-create.component.html"
})
export class CreditNoteCreateComponent implements OnInit {
  contentHeader: IContentHeader;
  invoices: IInvoice[] = [];
  filteredInvoicesForCreditNote: any = [];
  filterInvoice: IInvoice
  invoiceForm: FormGroup;
  expireInDays: number = 30;
  showErrors = false;
  credit_note_types: any = [];
  customersList: any = [];
  filterYear: number = moment().year();
  years = Array.from({ length: this.filterYear - 2024 + 2 }, (v, i) => 2024 + i);
  document_codes: { id: number; name: string; other: { code: string } }[] = [];
  payment_measure_units: any = [];
  rows_types: any = [];
  payment_terms: any = [];
  invoice_services: any = [];
  clickedOnSave: boolean = true;
  rowsToManipulate: number[] = [];

  attachments_list = []

  private defaultRowType: number | undefined;
  private defaultServiceTrack: any;

  constructor(
    public _invoiceService: InvoiceService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    public _utilsService: UtilsService
  ) {
    this.contentHeader = {
      headerTitle: "CREATE_CREDIT_NOTE",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/"
          },
          {
            name: "MENU.INVOICES",
            isLink: false
          },
          {
            name: "MENU.INVOICES_TO_GENERATE",
            isLink: true,
            link: "/dashboard/invoice/to-generate"
          },
          {
            name: "CREATE_CREDIT_NOTE",
            isLink: false
          }
        ]
      }
    };
  }

  async ngOnInit(): Promise<void> {
    this.loadInvoices();

    this.invoiceForm = this._invoiceService.buildForm(true);

    this.invoiceForm.get("invoice_order_number").setValidators([Validators.required]);
    this.invoiceForm.get("invoice_order_number").updateValueAndValidity();
    this.invoiceForm.patchValue({ has_client_approval: true });

    const itemsForLists = await this._invoiceService.itemsForLists();
    this.credit_note_types = itemsForLists.credit_note_types;
    this.document_codes = itemsForLists.document_codes;
    this.payment_measure_units = itemsForLists.payment_measure_units;
    this.rows_types = itemsForLists.rows_types;
    this.invoice_services = itemsForLists.invoice_services;
    this.payment_terms = itemsForLists.payment_terms;

    this.defaultRowType = this.rows_types.find((type: any) => !!type.other.default)?.id;
    this.defaultServiceTrack = this.invoice_services.find((service: any) => !!service.other.default) || {};

    this.addRow();
  }

  get rows() {
    return this.invoiceForm.controls.rows as FormArray;
  }

  loadInvoices() {
    this._invoiceService.getCompleted(this.filterYear)
      .subscribe((invoices) => {
        this.invoices = invoices as IInvoice[];
        invoices.map((inv) => {
          if (!this.customersList.find((customer: any) => customer.id === inv.client.id)) {
            this.customersList.push({ id: inv.client.id, name: inv.client.name });
          }
        });
        this.cdr.detectChanges();
      });
  }

  addRow() {
    const newRow = this._invoiceService.buildRow(this.rows.length + 1, this.defaultRowType, this.defaultServiceTrack.id);
    newRow.patchValue({ vat_code: this.defaultServiceTrack.other.sales_vat });
    this.rows.push(newRow);
    this._invoiceService.openLastRow();
  }

  selectClient() {
    const { client_id } = this.invoiceForm.value;
    this.invoiceForm.patchValue({
      order_id: null,
      order_product_id: null,
      order_child_id: null,
      invoice_order_number: null,
      order_number: null
    });
    this.filteredInvoicesForCreditNote = this.invoices.filter((invoice: any) => invoice.client.id === client_id);
    this.filterInvoice = null;
  }

  setOrderForCreditNote() {
    const invoice = this.filterInvoice;
    const additional_data: any = this._invoiceService.explodeAdditionalData(invoice.additional_data);

    this.invoiceForm.patchValue({
      order_id: invoice.order_id,
      order_product_id: invoice.order_product_id,
      order_child_id: invoice.order_child_id,
      invoice_order_number: additional_data.IdDocumento,
      order_number: additional_data.IdDocumento
    });

    if (!!invoice.order_product_id) {
      this.invoiceForm.get("order_id").setValidators(null);
      this.invoiceForm.get("order_id").updateValueAndValidity();
    } else {
      this.invoiceForm.get("order_product_id").setValidators(null);
      this.invoiceForm.get("order_product_id").updateValueAndValidity();
    }
  }

  handlerChangePaymentTerms() {
    const paymentTerm: any = this.payment_terms.find((pt: any) => pt.id === this.invoiceForm.value.payment_terms);
    this.expireInDays = paymentTerm?.other?.day_value || 30;
    if (!this.invoiceForm.value.document_date) return;
    this.handlerChangeDocumentDate();
  }

  handlerChangeDocumentDate() {
    const date: moment.Moment = utc(this.invoiceForm.value.document_date);
    date.add(this.expireInDays/30, "months");
    const paymentTerm: any = this.payment_terms.find((pt: any) => pt.id === this.invoiceForm.value.payment_terms);
    if (paymentTerm && paymentTerm.other.payment_end_month) {
      date.endOf("month");
    }
    // aggiorno forzatamente input expiration_date
    setTimeout(() => {
      const boxExpireDate: any = document.querySelector("#expiration_date input");
      if (boxExpireDate) boxExpireDate.value = date.format("YYYY-MM-DD");
      this.invoiceForm.patchValue({ expiration_date: date.format("YYYY-MM-DD"), accrual_exercise: moment(this.invoiceForm.value.document_date).year() });
    });
    this.cdr.detectChanges();
  }

  fieldHasError(field: string) {
    return this._invoiceService.fieldHasError(this.invoiceForm, field, this.showErrors);
  }

  toggleSelectRow(index: number) {
    if (this.rowsToManipulate.includes(index)) {
      this.rowsToManipulate = this.rowsToManipulate.filter((item) => item !== index);
    } else {
      this.rowsToManipulate.push(index);
    }
  }

  selectAllToDelete() {
    this.rowsToManipulate = this.rows.controls.map((row) => row.value.id);
  }

  removeRows() {
    if (!this.rowsToManipulate.length) return false;

    const controls = this.rows.controls;
    this.rowsToManipulate.map((row) => {
      const findIndex = controls.findIndex((row2: any) => Number(row2.value.id) === row);
      this.rows.removeAt(findIndex);
    });

    this.rowsToManipulate = [];

    if (!this.rows.length) {
      this.addRow();
    }

    this.calculateTotalAmount();
  }

  calculateTotalAmount(){
    setTimeout(() => {
      this.invoiceForm.patchValue({ total_amount: this._invoiceService.calculateTotalAmount(this.rows) });
    });
  }

  handlerAction() {
    this.showErrors = true;
    this.clickedOnSave = true;

    // controllo valori
    if (this.invoiceForm.invalid) {
      for (const key of Object.keys(this.invoiceForm.controls)) {
        if (key === "rows") continue;
        if (this.invoiceForm.controls[key].status !== "VALID") {
          console.warn(`${key} is invalid`);
          const input: any = document.querySelector(`*[formcontrolname="${key}"]`);
          if (input) {
            input?.scrollIntoView({ behavior: "smooth", block: "start" });
            input?.focus();
          }
        }
      }

      for (const key of Object.keys(this.rows.controls)) {
        if (this.rows.controls[key].status !== "VALID") {
          console.warn(`${key} is invalid`);
        }
      }
      this.clickedOnSave = false;
      return false;
    }

    const order_date = this.invoiceForm.value.order_date ? moment(this.invoiceForm.value.order_date).format("DD/MM/YYYY") : null;

    const values: any = {
      ...this.invoiceForm.value,
      isBlank: true,
      rows: this.invoiceForm.value.rows.filter((row: any) => row !== null),
      additional_data: `[DatiOrdineAcquisto|IdDocumento|${this.invoiceForm.value.invoice_order_number || 0}];[DatiOrdineAcquisto|Data|${order_date}]`,
      attachments: this.attachments_list || []
    };

    delete values.order_number;
    delete values.order_date;

    this.clickedOnSave = false;

    this._utilsService.showLoading();
    this._invoiceService.insert(values).subscribe((result) => {
      if (result && result.id && result.id > 0) {
        this.router.navigateByUrl("/dashboard/invoice/to-generate");
        this._utilsService.showToastrSuccess("SUCCESS_INSERT_CREDIT_NOTE");
      }
    });
  }
}
